import type { IconSvgObject } from './types';

const InequalityCircle02Icon: IconSvgObject = [
  ["path", { d: "M12 22C6.4772 22 2 17.5228 2 12C2 6.47715 6.4772 2 12 2C17.5229 2 22 6.47715 22 12C22 17.5228 17.5229 22 12 22Z", stroke: "currentColor", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M10.0201 7.5L15.8641 12.6714C16.2001 13.08 15.8711 13.5 15.4201 13.5H8.00415", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M16.0195 16.5H7.99773", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default InequalityCircle02Icon;
